<template>
  <div>
    <Success
      v-if="success"
      :courseInfo="courseInfo"
      @jumpExchange="jumpExchange"
    />
    <div
      v-else
      class="exchange-page"
      :class="{
        'pad-exchange-page': isMGAppInPad,
        'h5-exchange-page': isH5 && !isMGAppInPad,
        'pc-exchange-page': !isH5 && !isMGAppInPad,
        'electron-exchange-page': isElectron,
      }"
    >
      <div class="page-wrap">
        <p class="page-title" :class="{ 'app-title': isHXApp }">课程兑换</p>
        <div class="page-cont">
          <el-input
            class="code-input"
            v-model.trim="code"
            placeholder="请输入兑换码"
            maxlength="50"
          ></el-input>

          <button
            @click="submitCode"
            v-preventReClick
            :disabled="submiting"
            class="exchange-btn"
          >
            <img
              v-if="isAuthenticated"
              src="../../assets/images/exchange/exchange-btn.png"
              alt=""
            />
            <img
              v-else
              src="../../assets/images/exchange/login-btn.png"
              alt=""
            />
          </button>

          <div class="tips">
            <p class="title">兑换说明：</p>
            <p>
              1.兑换课程后，可在「魔果云课」App
              中进行学习，各应用市场搜索即可下载 App。
            </p>
            <p>2.如有疑问，请联系您购买课程所属的机构。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Success from "./Success";
import { convertCdKey } from "@saas/server-api/src/enrollment";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { mapGetters, mapActions } from "vuex";
import { isHXApp, isH5, isMGAppInPad } from "@saas/components";
import { EventBus } from "@saas/components/src/utils/event-bus";

export default {
  data: function () {
    return {
      code: "",
      isHXApp: isHXApp(),
      isH5: isH5(),
      submiting: false,
      isMGAppInPad: isMGAppInPad(),
      success: false,
      courseInfo: {},
      isElectron: window.isElectron,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    ...mapActions(["getProfile"]),
  },
  mounted() {
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        if (isLogin) {
          this.getProfile();
        }
      });
    }
  },
  components: {
    Success,
  },
  methods: {
    jumpExchange() {
      this.courseInfo = {};
      this.success = false;
    },
    submitCode() {
      if (this.isAuthenticated) {
        if (!this.code) {
          this.$showToast("请输入兑换码");
          return false;
        }
        if (this.submiting) return false;
        this.submiting = true;
        let params = {
          cdkey: this.code,
        };
        convertCdKey(params).then((res) => {
          if (res.code === 1) {
            // this.$showToast("兑换完成");
            this.code = "";
            this.courseInfo = res.data || {};
            this.success = true;
          } else {
            this.$showToast(res.message);
          }
          this.submiting = false;
        });
      } else {
        this.jumpLoginPage();
      }
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
      } else {
        this.$loginDialog({
          exchangeCode: this.code,
        });
      }
    },
  },
  watch: {
    isAuthenticated: {
      handler(newValue) {
        if (newValue !== null) {
          if (newValue) {
            this.code = localStorage.getItem("exchangeCode") || "";
          }
          localStorage.removeItem("exchangeCode");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-exchange-page {
  height: 100vh;
  background: linear-gradient(90deg, #fff6f7 0%, #ffe7e6 100%);
  .page-wrap {
    background-image: url("../../assets/images/exchange/exchange-bg.png");
    background-repeat: no-repeat;
    background-size: 8.72rem 8.16rem;
    background-position: center 0.56rem;
  }
  .app-title {
    opacity: 0;
  }
  .page-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.2rem;
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.59rem;
  }
  .page-cont {
    padding: 0 0.64rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .code-input {
    margin: 3.47rem auto 1.04rem;
    width: 7.76rem;
    border-radius: 0.32rem;
    ::v-deep input {
      background: #ffffff;
      height: 1.2rem;
    }
    ::v-deep .el-input__inner {
      border-radius: 0.32rem;
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 0.4rem;
      color: #858687;
    }
  }
  .exchange-btn {
    img {
      width: 4.64rem;
      height: 1.79rem;
    }
  }
  .tips {
    .title {
      font-weight: 500;
    }
    margin-top: 0.53rem;
    font-weight: 400;
    font-size: 0.37rem;
    color: #515350;
    line-height: 0.59rem;
  }
}
.pc-exchange-page {
  min-height: calc(100vh - #{$nav-bar-height} - #{$nav-footer-height});
  background: linear-gradient(90deg, #fff6f7 0%, #ffe7e6 100%);
  padding-top: 22px;
  padding-bottom: 40px;
  .page-wrap {
    width: 425px;
    margin: 0 auto;
    background-image: url("../../assets/images/exchange/exchange-bg.png");
    background-repeat: no-repeat;
    background-size: 425px auto;
    background-position: center top;
  }
  .page-title {
    display: none;
  }
  .page-cont {
    padding: 0 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .code-input {
    margin: 212px auto 47px;
    width: 365px;
    font-weight: 400;
    font-size: 15px;
    color: #0d1400;
    ::v-deep input {
      background: #ffffff;
      height: 45px;
    }
    ::v-deep .el-input__inner {
      border-radius: 12px;
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 15px;
      line-height: normal;
      color: #858687;
    }
  }
  .exchange-btn {
    img {
      width: 174px;
      height: 67px;
    }
  }
  .tips {
    .title {
      font-weight: 500;
    }
    margin-top: 40px;
    font-size: 14px;
    color: #515350;
    line-height: 22px;
  }
}

.pad-exchange-page {
  height: 100vh;
  background: linear-gradient(90deg, #fff6f7 0%, #ffe7e6 100%);
  .page-wrap {
    width: 375px;
    margin: 0 auto;
    background-image: url("../../assets/images/exchange/exchange-bg.png");
    background-repeat: no-repeat;
    background-size: 327px 306px;
    background-position: center 21px;
  }
  .app-title {
    opacity: 0;
  }
  .page-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
  }
  .page-cont {
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .code-input {
    margin: 130px auto 39px;
    width: 291px;
    font-weight: 400;
    font-size: 15px;
    color: #0d1400;
    ::v-deep input {
      background: #ffffff;
      height: 45px;
    }
    ::v-deep .el-input__inner {
      border-radius: 12px;
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 15px;
      line-height: normal;
      color: #858687;
    }
  }
  .exchange-btn {
    img {
      width: 174px;
      height: 67px;
    }
  }
  .tips {
    .title {
      font-weight: 500;
    }
    margin-top: 20px;
    font-size: 14px;
    color: #515350;
    line-height: 22px;
  }
}
.electron-exchange-page {
  min-height: calc(100vh - #{$top-bar-height});
}
</style>
